import styles from "./S6_TrackOrder.module.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  Skeleton,
  Typography,
} from "@mui/material";
import { ButtonCust, StepperCustNew } from "../widgets";
import Config from "../../config/env.config.json";
import { pushTrackingEventsToGAAndFB } from "../../utils/commonFunctions/GaAndFb";
import {
  gaEventTypes,
  gaScreenNames,
  gaCategory,
  gaEvents,
} from "../../Types/GoogleAnalytics";
import {
  StepperStatus,
  OrderStatus,
} from "../../features/trackorder/trackOrder";
import { CustomerStatus } from "../../enums";
import EnvConfig from "../../config/env.config.json";
import { useAppSelector } from "../../app/hooks";
import { RoutingURLs } from "../../config/RoutingURLs";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { BrandNameUpdate } from "../../utils/commonFunctions/BrandNameUpdate";
import trackorder from "../../assets/Common/trackorder.svg";
import { InternalBanner } from "../common";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  gtmTagManager,
  isLandingPage,
  isPromotionalLandingPage,
} from "../../utils";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const T6_TrackOrder = (props: any) => {
  const navigate = useNavigate();
  const {
    content,
    trackOrderData,
    planData,
    customerData,
    shipmentTrackingOpsMessages,
  } = props;
  const [trackingLoader, setTrackingLoader] = useState<boolean>(true);
  const [discountInDollar, setDiscountInDollar] = useState<number | null>(null);
  const GAAndFBEventsHandler = () => {
    pushTrackingEventsToGAAndFB(gaEventTypes.event, gaEventTypes.click, {
      appName: EnvConfig.brand,
      screenName: gaScreenNames.trackOrder,
      category: gaCategory.activation,
      buttonValue: content.act_now,
    });
  };
  const { trackOrderStatus, currentOderNo } = useAppSelector(
    (state: any) => state?.trackorder || {}
  );
  const { coupon } = useAppSelector((state: any) => state.checkout);

  useEffect(() => {
    if (isLandingPage() || isPromotionalLandingPage()) {
      let couponDetails = localStorage.getItem("couponDetails");
      if (couponDetails) {
        const parsedCouponDetails = JSON.parse(couponDetails);
        setDiscountInDollar(parsedCouponDetails.discountInDollar);
      }
    }
  }, []);

  useEffect(() => {
    if (currentOderNo) {
      setTrackingLoader(false);
    }
  }, [currentOderNo]);
  const onClickHandler = (navigationPath: string, redirectionPage: string) => {
    if (EnvConfig.IS_APN_SETTINGS_DETAILS_SCREEN_NEEDED) {
      // navigationPath = RoutingURLs.deviceConfirmCheck;
      navigationPath = navigationPath;
    }
    if (redirectionPage === "_self") {
      navigate(navigationPath);
    } else {
      window.open(navigationPath, redirectionPage);
    }
    GAAndFBEventsHandler();
  };
  const onArrowBack = () => {
    if (customerData?.additionalLines >= 1) {
      navigate(RoutingURLs.account, {
        state: {
          navigateFromNotification: true,
        },
      });
    } else {
      navigate(RoutingURLs.myAccount);
    }
  };

  const getSteps = () => {
    if (trackOrderData.cId && customerData.id) {
      let time = new Date(trackOrderData.orderDate);
      let time1 = time
        .toLocaleString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        ?.replace(/ /g, "")
        ?.toLowerCase();

      let labeledTime: any = trackOrderData.labelledOn
        ? new Date(trackOrderData.labelledOn)
        : "";
      let labeled1: any = labeledTime
        ? labeledTime
            .toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
            ?.replace(/ /g, "")
            ?.toLowerCase()
        : "";

      let dateDelivery: any = trackOrderData.deliveredOn
        ? new Date(trackOrderData.deliveredOn)
        : trackOrderData.estimatedDeliveryDate
        ? new Date(trackOrderData.estimatedDeliveryDate)
        : "";
      let dateDelivery1: any = dateDelivery
        ? dateDelivery
            .toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
            ?.replace(/ /g, "")
            ?.toLowerCase()
        : "";

      let shippedTime: any = trackOrderData.shippedOn
        ? new Date(trackOrderData.shippedOn)
        : "";
      let shippedTime1: any = shippedTime
        ? shippedTime
            .toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
            ?.replace(/ /g, "")
            ?.toLowerCase()
        : "";
      let cancelledTime: any = trackOrderData.orderCanceledOn
        ? new Date(trackOrderData.orderCanceledOn)
        : "";
      let cancelledTime1: any = cancelledTime
        ? cancelledTime
            .toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
            ?.replace(/ /g, "")
            ?.toLowerCase()
        : "";
      let stepperObj = [
        {
          label: StepperStatus.OrderReceived,
          text: `${
            months[time.getMonth()]
          } ${time.getDate()}, ${time.getFullYear()} at ${time1}`,
          icon: content?.received_status_icon?.data?.attributes?.url,
          labeltext: StepperStatus.OrderInitiated,
          date: `${time.getDate()} ${
            months[time.getMonth()]
          }, ${time.getFullYear()} `,
          simcards: trackOrderStatus?.data?.items
            ?.map((obj: any) => obj?.quantity)
            .reduce((acc: any, cur: any) => acc + cur, 0),
          simCardLabel: `${content.sim_cards_text}`,
          keyProp: 0,
        },
        {
          label: StepperStatus.InProcess,
          text:
            labeledTime &&
            labeled1 &&
            `${
              months[labeledTime.getMonth()]
            } ${labeledTime.getDate()}, ${labeledTime.getFullYear()} at ${labeled1}.`,
          labeltext: content?.in_pro_text,
          icon: content?.Inprogress_status_icon?.data?.attributes?.url,
          simCardLabel: null,
          simcards: null,
          keyProp: 1,
        },
        {
          label: StepperStatus.OrderShipped,
          text:
            shippedTime &&
            shippedTime1 &&
            `${
              months[shippedTime.getMonth()]
            } ${shippedTime.getDate()}, ${shippedTime.getFullYear()} at ${shippedTime1}.`,
          labeltext: content?.order_sh_text,
          icon: content?.shipped_status_icon?.data?.attributes?.url,
          simCardLabel: null,
          simcards: null,
          keyProp: 2,
        },
        {
          label: StepperStatus.DELIVERED,
          text:
            trackOrderData.orderStatus === OrderStatus.Delivered
              ? `${
                  months[dateDelivery.getMonth()]
                } ${dateDelivery.getDate()}, ${dateDelivery.getFullYear()} at ${dateDelivery1}.`
              : "",
          labeltext: StepperStatus.OrderDelivered,
          icon: content?.delivered_status_icon?.data?.attributes?.url,
          estimatedDelivery: `${
            months[dateDelivery.getMonth()]
          } ${dateDelivery.getDate()}, ${dateDelivery.getFullYear()}`,
          simCardLabel: null,
          simcards: null,
          keyProp: 3,
        },
      ];
      let finalStepperObj: any[] = [];
      if (trackOrderData.orderStatus === OrderStatus.Cancelled) {
        const cancelledObj = [
          {
            label: StepperStatus.Cancelled,
            text:
              cancelledTime && cancelledTime1
                ? `${content.cancel_txt}${"\n"} ${cancelledTime.getDate()} ${
                    months[cancelledTime.getMonth()]
                  }, ${cancelledTime.getFullYear()}${"\n"}
                  ${cancelledTime1}`
                : `${content.cancel_txt}`,
            simCardLabel: null,
            simcards: null,
            keyProp: 4,
          },
        ];
        if (trackOrderData.lastOrderStatus === OrderStatus.Ordered) {
          finalStepperObj.push(stepperObj[0], ...cancelledObj);
        }
      } else {
        finalStepperObj = [...stepperObj];
      }
      return finalStepperObj;
    } else {
      return [{ label: StepperStatus.OrderReceived }, {}, {}, {}];
    }
  };

  const renderLiveOpsMessages = () => {
    if (shipmentTrackingOpsMessages?.length <= 0) return null;
    return (
      <Typography component="div" sx={{ m: "20px 40px", textAlign: "left" }}>
        <Typography
          component="div"
          sx={{
            color: "var(--primary_brand_color)",
            fontSize: "16px",
            fontFamily: "var(--font_family_Medium)",
          }}
        >
          Note:
        </Typography>
        {shipmentTrackingOpsMessages.map((opsMessage: any) => {
          return (
            <Typography
              component="div"
              sx={{
                fontFamily: "var(--font_family_Semibold)",
                fontSize: "14px",
                wordBreak: "break-all",
              }}
              key={opsMessage.id}
            >
              <Typography
                component="span"
                sx={{
                  fontFamily: "var(--font_family_Medium)",
                  fontSize: "inherit",
                }}
              >
                {opsMessage.messageType}:{" "}
              </Typography>
              {opsMessage.message}
            </Typography>
          );
        })}
      </Typography>
    );
  };

  let activeStep: number = 0;
  if (trackOrderData && trackOrderData.cId) {
    activeStep =
      trackOrderData.orderStatus === OrderStatus.Ordered
        ? 0
        : trackOrderData.orderStatus === OrderStatus.Labelled ||
          trackOrderData.orderStatus === OrderStatus.Cancelled
        ? 1
        : trackOrderData.orderStatus === OrderStatus.Shipped
        ? 2
        : trackOrderData.orderStatus === OrderStatus.Delivered
        ? 3
        : 0;
  }

  let stepsData: any = getSteps();
  let customerDetails: any = JSON.parse(
    localStorage.getItem("customerDetail") || "null"
  );

  return (
    <>
      {/* <InternalBanner
        // key={key}
        pageName={"MyAccount"}
        apiEndPoint={"myAccBanner"}
        type={"internal"}
      /> */}
      <Box
        sx={{
          background: "var(--lightgrey)",
          paddingTop: { xs: "28px", sm: "50px" },
        }}
      >
        <Box
          onClick={() => {
            customerDetails.status === CustomerStatus.ACTIVE
              ? navigate(RoutingURLs.postActivationHome)
              : navigate(RoutingURLs.myAccount);
          }}
          sx={{
            display: { xs: "none", sm: "flex" },
            width: "18px",
            height: "18px",
            position: "absolute",
            left: "5rem",
            cursor: "pointer",
          }}
        >
          <ArrowBackIosIcon sx={{ width: "18px" }} />
          <Box
            sx={{
              fontFamily: "var(--font_family_Regular)",
              fontSize: "18px",
              fontWeight: "var(font_weight_1)",
              lineHeight: "24px",
            }}
          >
            {content?.back}
          </Box>
        </Box>
        <KeyboardBackspaceIcon
          onClick={() => {
            customerDetails.status === CustomerStatus.ACTIVE
              ? navigate(RoutingURLs.postActivationHome)
              : navigate(RoutingURLs.myAccount);
          }}
          fontSize="large"
          sx={{
            display: { xs: "block", sm: "none" },
            position: "absolute",
            top: "91.5px",
            left: "20px",
            color: "var(--internal_back_arrow_color, var(--white))",
          }}
        />
        <Typography
          component={"h5"}
          variant={"h5"}
          fontFamily={"var(--font_family_Bold)"}
          pb={{ xs: "25px", sm: "20px" }}
          textAlign="center"
          width="100%"
          sx={{
            fontSize: { xs: "18px", md: "24px" },
            color: "var(--title-color_1)",
          }}
        >
          {content.title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Paper
            sx={{
              // border: "1px solid rgba(0,0,0,.2)",
              width: { xs: "92%", sm: "60%" },
              // height: "600px",
              display: "flex",
              // justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              // mt: { xs: "12px" },
              boxShadow: { xs: "unset !important" },
              marginBottom: "45px",
            }}
          >
            <Box
              component="p"
              sx={{
                fontFamily: "var(--font_family_Bold)",
                mt: "30px",
                mb: "20px",
                lineHeight: "30px",
                color: "var(--text_color)",
                fontWeight: "var(--font_weight_4)",
                fontSize: { xs: "20px", sm: "28px" },
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
              }}
            >
              {planData &&
              planData.displayName &&
              customerData &&
              customerData.id ? (
                <>
                  {planData.displayName}&nbsp;-&nbsp;
                  <Box
                    component="span"
                    sx={{
                      color: "var(--primary_color)",
                      fontFamily: "var(--font_family_Bold)",
                      fontSize: { xs: "20px", sm: "28px" },
                      lineHeight: "30px",
                      fontWeight: "var(--font_weight_4)",
                    }}
                  >
                    $
                    {planData &&
                      planData.baseLinePrice &&
                      (discountInDollar
                        ? (
                            planData.baseLinePrice - Number(discountInDollar)
                          ).toFixed()
                        : (
                            planData.baseLinePrice -
                            (coupon?.discountInDollar || 0)
                          ).toFixed())}
                  </Box>
                  <Box
                    component="p"
                    sx={{
                      fontSize: "12px",
                      fontFamily: "var(--font_family_Medium)",
                      color: "var(--text_color)",
                      margin: "0px",
                    }}
                  >
                    {content?.plan_perMonth}
                  </Box>
                </>
              ) : null}
            </Box>
            <Box sx={{ textAlign: "center", pb: "18px" }}>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--text_color)",
                  fontFamily: "var(--font_family_Semibold)",
                  fontSize: { xs: "14px", sm: "18px" },
                  lineHeight: { xs: "23px", sm: "30px" },
                  fontWeight: "var(--font_weight_2)",
                  margin: { xs: "0 10%", sm: "0" },
                  pt: { xs: "5px" },
                }}
              >
                {content?.psim_ordertxt} &nbsp;
                {!currentOderNo ? (
                  <Box component="span" className={styles.order_circle}>
                    <Skeleton variant="rectangular" width={70} height={20} />
                  </Box>
                ) : (
                  currentOderNo
                )}
              </Typography>
              <Box
                component={"p"}
                sx={{
                  color: "var(--lite_black_3)",
                  fontFamily: "var(--font_family_Semibold)",
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: { xs: "23px", sm: "26px" },
                  fontWeight: "var(--font_weight_2)",
                  p: "5px 0px 5px 10px",
                  m: "0px",
                }}
              >
                {stepsData?.map((item: any, index: number) => {
                  return item.estimatedDelivery ? (
                    <>
                      {`${content?.estimated_delivery_txt} ${item.estimatedDelivery}`}
                    </>
                  ) : null;
                })}
              </Box>
            </Box>
            <Box sx={{ width: "100%", textAlign: "center" }}>
              <Divider
                style={{ border: "1px solid var(--lightgrey_6)" }}
              ></Divider>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: { xs: "column-reverse", sm: "column" },
              }}
            >
              <StepperCustNew
                activeStep={activeStep}
                steps={getSteps()}
                stepsData={stepsData}
                stepOneExtraContentTR={true}
                orderStatus={trackOrderData.orderStatus}
                {...props}
                sx={{
                  padding: { xs: "5px", sm: "24px" },
                  textAlign: "center",
                  width: { xs: "100%", sm: "540px" },
                }}
              />
              <Box
                sx={{
                  fontSize: "18px",
                  color: "var(--lite_black_3)",
                  fontFamily: "var(--font_family_Semibold)",
                  my: "10px",
                  marginLeft: {
                    xs: "0px",
                    sm: activeStep > 2 ? "-18%" : "0%",
                  },
                  textAlign: "center",
                }}
              >
                {content?.shipment_progress_txt}
              </Box>
              <Box></Box>
              {trackingLoader ? (
                <>
                  <Skeleton
                    animation="wave"
                    width="100%"
                    height={25}
                    sx={{ borderRadius: "2px", my: "5px" }}
                  />
                  <Skeleton
                    animation="wave"
                    width="100%"
                    height={25}
                    sx={{ borderRadius: "2px" }}
                  />
                  <Skeleton
                    animation="wave"
                    width="100%"
                    height={25}
                    sx={{ borderRadius: "2px", my: "5px" }}
                  />
                  <Skeleton
                    animation="wave"
                    width="100%"
                    height={25}
                    sx={{ borderRadius: "2px" }}
                  />
                </>
              ) : (
                <Box
                  sx={{
                    display: { xs: "none", sm: "flex" },
                    justifyContent: "center",
                    marginBottom: { xs: "20px", sm: "15px" },
                  }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="baseline"
                  >
                    {stepsData &&
                      stepsData
                        ?.filter(
                          (data: any, index: number) => index <= activeStep
                        )
                        .map((item: any, index: number) => {
                          return (
                            <Box display="flex" padding="15px" key={index}>
                              <Box
                                component="img"
                                alt={"circular_loader"}
                                src={item?.icon}
                                sx={{
                                  width: { xs: "25px" },
                                  mr: "20px",
                                  height: "25px",
                                }}
                              />
                              <Box display="flex" flexDirection="column">
                                <Typography
                                  sx={{
                                    fontFamily: "var(--font_family_Regular)",
                                    fontSize: "14px",
                                    fontWeight: "var(--font_weight_0)",
                                    lineHeight: "25px",
                                    color: "var(--text_color)",
                                  }}
                                >
                                  {item?.labeltext}
                                </Typography>
                                <Box
                                  sx={{
                                    color: "var(--text_color)",
                                    fontSize: "14px",
                                    lineHeight: "25px",
                                    fontWeight: "var(--font_weight_2)",
                                    "& > span": {
                                      fontFamily:
                                        "var(--font_family_Semibold) !important",
                                    },
                                  }}
                                >
                                  {item.text &&
                                    item.text.split("\n").map((i: any) => {
                                      return <span>{i}</span>;
                                    })}
                                </Box>
                              </Box>
                            </Box>
                          );
                        })}
                  </Box>
                </Box>
              )}
            </Box>
            <Box textAlign="center" sx={{ m: { xs: "3px 0px 20px" } }}>
              {trackOrderData?.orderStatus !== OrderStatus.Cancelled && (
                <>
                  {content?.res?.home_btn && activeStep !== 3 ? (
                    <Box>
                      <ButtonCust
                        sx={{ width: "250px" }}
                        variantType={Config.PRIMARY_BUTTON_TYPE}
                        onClick={() => {
                          if (
                            customerData?.isPrimary &&
                            customerData?.status === CustomerStatus.ACTIVE
                          ) {
                            navigate(RoutingURLs.postActivationHome);
                          } else {
                            navigate(content?.res?.home_btn_url);
                          }
                        }}
                      >
                        {content?.res?.home_btn}
                      </ButtonCust>
                    </Box>
                  ) : EnvConfig.TRACK_ORDER_ACTIVATE_BTN ? (
                    <Box>
                      <ButtonCust
                        disabled={activeStep === 3 ? false : true}
                        variantType={Config.PRIMARY_BUTTON_TYPE}
                        onClick={() =>
                          onClickHandler(RoutingURLs.activation, "_self")
                        }
                        sx={{ width: { xs: "200px", sm: "250px" } }}
                      >
                        {content.btn_text}
                      </ButtonCust>
                    </Box>
                  ) : (
                    <>
                      {activeStep === 3 && (
                        <Box mb="20px">
                          <ButtonCust
                            variantType={Config.PRIMARY_BUTTON_TYPE}
                            onClick={() =>
                              onClickHandler(RoutingURLs.activation, "_self")
                            }
                          >
                            {content.btn_text}
                          </ButtonCust>
                        </Box>
                      )}
                    </>
                  )}

                  {trackOrderData?.orderStatus !== OrderStatus.Delivered && (
                    <>
                      <Box
                        sx={{
                          fontFamily: "var(--font_family_Medium)",
                          fontSize: "16px",
                          letterSpacing: " normal",
                          textAlign: "center",
                          color: "var(--text_color)",
                          fontWeight: "var(--font_weight_1)",
                          lineHeight: "24px",
                          margin: { xs: "25px 10% 0px", sm: "20px 0px 0px" },
                        }}
                        mt="32px"
                      >
                        {content?.rec_kit}
                        <Box
                          component={"span"}
                          textAlign={{ xs: "center" }}
                          sx={{
                            fontSize: "16px",
                            lineHeight: "24px",
                            pl: { xs: "5px", sm: "5px" },
                            fontFamily: "var(--font_family_Semibold)",
                            fontWeight: "var(--font_weight_2)",
                            cursor: "pointer",
                            color: "var(--primary_color)",
                          }}
                          onClick={() => {
                            onClickHandler(RoutingURLs.activation, "_self");
                            gtmTagManager({
                              event: gaEvents?.activationInitiated,
                              simType: "psim",
                            });
                          }}
                        >
                          {content?.act_now}
                        </Box>
                      </Box>
                    </>
                  )}
                  {trackOrderData?.orderStatus === OrderStatus.Delivered && (
                    <>
                      <Box
                        component={"p"}
                        textAlign={{ xs: "center" }}
                        sx={{
                          fontSize: "14px",
                          lineHeight: "24px",
                          margin: "20px 0px 0px",
                          fontFamily: "var(--font_family_Semibold)",
                          fontWeight: "var(--font_weight_2)",
                          cursor: "pointer",
                          color: "var(--primary_color)",
                        }}
                        onClick={() =>
                          onClickHandler(RoutingURLs.myAccount, "_self")
                        }
                      >
                        {content?.res?.return_to_home}
                      </Box>
                    </>
                  )}
                  {Config.FREE_SHIPPING_ACTIVATED &&
                  customerData?.status === CustomerStatus.INACTIVE &&
                  content?.track_img?.data?.attributes?.url ? (
                    <>
                      <Box
                        sx={{
                          width: "40px",
                          height: "35px",
                        }}
                        mt="30px"
                        mb="10px"
                        component="img"
                        src={content?.track_img?.data?.attributes?.url || ""}
                        alt={
                          content?.track_img?.data?.attributes?.alternativeText
                        }
                      />
                      <Box
                        sx={{
                          fontFamily: "var(--font_family_Semibold)",
                          fontSize: "14px",
                          fontWeight: "var(--font_weight_0)",
                          letterSpacing: " normal",
                          lineHeight: "21px",
                          textAlign: "center",
                          color: "var(--text_color_5)",
                          margin: {
                            xs: "0 18px 0",
                            sm: "0 10% 0",
                            md: "0 16% 0",
                          },
                        }}
                      >
                        {BrandNameUpdate(content.act_your_line)}
                      </Box>
                    </>
                  ) : null}
                </>
              )}
            </Box>
            <Box
              px="90px"
              mb="20px"
              width={{xs: "85%", sm: "75%"}}
              display="flex"
              justifyContent="center"
              alignItems="baseline"
              sx={{ flexDirection: { xs: "column", sm: "column" } }}
            >
              <Box
                component="span"
                sx={{
                  color: "var(--button_secondary_color) !important",
                  fontSize: "14px !important",
                  fontWeight: "var(--font_weight_0) !important",
                  fontFamily: "var(--font_family_Medium) !important",
                }}
              >
                {content?.res?.order_deliver_note}&nbsp;
              </Box>
              <Box
                component="p"
                textAlign={"start"}
                mt={{ xs: "0px" }}
                sx={{
                  lineHeight: 1.86,
                  color: "var(--button_secondary_color) !important",
                  fontSize: "14px !important",
                  fontWeight: "var(--font_weight_0) !important",
                  fontFamily: "var(--font_family_Regular) !important",
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontFamily: "var(--font_family_Regular)",
                    fontWeight: "var(--font_weight_0)",
                    fontSize: "14px",
                    lineHeight: "25px",
                    color: "var(--text_color)",
                  }}
                >
                  {content?.res?.note_desc}
                </Box>
                <Box
                  component={"span"}
                  sx={{
                    fontFamily: "var(--font_family_Regular)",
                    fontWeight: "var(--font_weight_0)",
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "var(--text_color)",
                    textAlign: "left",
                    width: { xs: "100%", sm: "100%" },
                    display: { xs: "inline", sm: "flow" },
                    paddingLeft: { xs: "5px", sm: "0px" },
                  }}
                >
                  {content?.res?.note_desc1}&nbsp;
                  <Box
                    component="a"
                    sx={{
                      color: "var(--primary_color)",
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                    href={content?.psim_clickhere_link}
                    target="_blank"
                  >
                    {content?.psim_clickhere_txt}
                  </Box>
                  .
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default T6_TrackOrder;
